export enum OrderActionType {
    clearRedirectedPaymentTimeoutId = 'clearRedirectedPaymentTimeoutId',
    removeOrderInstallments = 'removeOrderInstallments',
    resetOrder = 'resetOrder',
    saveEventShippingSettings = 'saveEventShippingSettings',
    saveWaitlistEntry = 'saveWaitlistEntry',
    setCanRetrySubmit = 'setCanRetrySubmit',
    setHasExternalPaymentFirstCallCompleted = 'setHasExternalPaymentFirstCallCompleted',
    setHasRetryPaymentError = 'setHasRetryPaymentError',
    setHasVirtualIncentivesErrors = 'setHasVirtualIncentivesErrors',
    setOrderInstallments = 'setOrderInstallments',
    setOrderUpdating = 'setOrderUpdating',
    setRedirectedPaymentTimeoutId = 'setRedirectedPaymentTimeoutId',
    taxPoliciesLoadComplete = 'taxPoliciesLoadComplete',
    updateAvailablePaymentMethods = 'updateAvailablePaymentMethods',
    updateBraintreeClientToken = 'updateBraintreeClientToken',
    updateOrder = 'updateOrder',
    updateOrderAttendees = 'updateOrderAttendees',
    updateOrderEmail = 'updateOrderEmail',
    updateOrderStatus = 'updateOrderStatus',
    updateRedirectInstructions = 'updateRedirectInstructions',
    updateTaxExemptionMessage = 'updateTaxExemptionMessage',
}
